import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { IonButton, IonPopover, IonList, IonIcon, IonItem } from '@ionic/react';
import { AppSelectors } from 'redux/AppRedux';
import PayActions, { PaySelectors } from 'redux/PayRedux';
import { Avatar } from 'components/common';
import { ellipsisVertical } from 'ionicons/icons';
import ShareModal from 'containers/tab/ShareModal';
import ClaimedItemsModal from 'containers/tab/ClaimedItems';
import get from 'lodash/get';
import './TicketUsers.css';
import SplitWarningModal from '../SplitWarningModal';

function TicketUsers({ venueId, ticket }) {
  const venue = useSelector(AppSelectors.selectVenueDetail);
  const users = useSelector(PaySelectors.selectTicketUsers);
  const dispatch = useDispatch();
  const [share, setShare] = useState(false);
  const [warning, setWarning] = useState(false);
  const [claim, setClaim] = useState(false);
  const [menu, setMenu] = useState(false);
  const [event, setEvent] = useState(undefined);

  const showMenu = (e) => {
    setEvent(e.nativeEvent);
    setMenu(true);
  };

  const handleRemove = async () => {
    dispatch(PayActions.deleteTicket());
    setMenu(false);
  };

  const showClaim = () => {
    setMenu(false);
    setClaim(true);
  };

  useEffect(() => {
    const loadUsers = async () => {
      try {
        dispatch(PayActions.setTicketUsers(ticket.users));
      } catch (error) {
        dispatch(PayActions.setTicketUsers([]));
      }
    };

    if (venueId && ticket) {
      loadUsers();
    }
  }, [ticket]);

  return (
    <IonItem className="no-padding-end">
      <div className="avatar-list">
        {users.map((u) => (
          <Avatar
            key={u.userId}
            firstName={u.firstName}
            lastName={u.lastName}
          />
        ))}
      </div>
      <IonButton slot="end" fill="clear" onClick={(e) => showMenu(e)}>
        <IonIcon slot="icon-only" icon={ellipsisVertical} />
      </IonButton>
      <ShareModal
        open={share}
        onClose={() => setShare(false)}
        venueId={venueId}
        ticketId={ticket && ticket.id}
      />
      <SplitWarningModal open={warning} onClose={() => setWarning(false)} />
      <ClaimedItemsModal
        open={claim}
        onClose={() => setClaim(false)}
        ticket={ticket}
      />
      <IonPopover
        className="popover-ticket-user"
        event={event}
        isOpen={menu}
        onDidDismiss={() => setMenu(false)}
      >
        <IonList>
          {!venue.isFullPay && !get(ticket, 'isPosPaymentMade') && (
            <IonItem button onClick={showClaim}>
              View Claimed Items
            </IonItem>
          )}
          <IonItem lines="none" button onClick={handleRemove}>
            Leave This Tab
          </IonItem>
        </IonList>
      </IonPopover>
    </IonItem>
  );
}

TicketUsers.propTypes = {
  venueId: PropTypes.string,
  ticket: PropTypes.object,
};

export default TicketUsers;
